import { useMediaQuery } from "@react-hook/media-query";
import React, { HTMLAttributes } from "react";
import { useInView } from "react-spring";
import SectionTitle from "../../atoms/sectionTitle";
import EvInfoSwiperDesktop from "./evSwiperDesktop";
import EvInfoSwiperMobile from "./evSwiperMobile";

export const REGION_LIST = [
  { name: "所有地區", eng_name: "All Regions", key: "all" },
  { name: "新界", eng_name: "New Territories", key: "nt" },
  { name: "九龍", eng_name: "Kowloon", key: "kl" },
  { name: "港島", eng_name: "Hong Kong Island", key: "hk" },
] as const;

export const PARKING_NAME_EN_MAP: Record<string, string> = {
  荃灣: "Tsuen Wan",
  火炭: "Fo Tan",
  觀塘: "Kwun Tong",
  大角咀: "Tai Kok Tsui",
  荔枝角: "Lai Chi Kok",
  牛頭角: "Ngau Tau Kok",
  // ...如有更多可自行補充
} as const;

export const STATION_INFO_MAP: Record<
  string,
  { name_eng: string; price: string; time_period: string; kwh: string }
> = {
  6: {
    name_eng: "International Enterprise Centre IEC3",
    price: "2.6",
    time_period: "00:00-24:00",
    kwh: "120",
  },
  12: {
    name_eng: "Arles",
    price: "2.6",
    time_period: "00:00-24:00",
    kwh: "120",
  },
  13: {
    name_eng: "-",
    price: "2.6",
    time_period: "00:00-24:00",
    kwh: "120",
  },
  2: {
    name_eng: "Khora",
    price: "2.5",
    time_period: "00:00-24:00",
    kwh: "40",
  },
  10: {
    name_eng: "Orient International Tower GCC3",
    price: "2.6",
    time_period: "00:00-24:00",
    kwh: "120",
  },
  24: {
    name_eng: "33 Hung To Road, Horizon Sea",
    price: "2.6",
    time_period: "00:00-24:00",
    kwh: "240",
  },
  // ...如有更多可自行補充
} as const;

export const REGION_DISTRICT_MAP: Record<string, number[]> = {
  hk: [1, 2, 3, 4],
  kl: [5, 6, 7, 8, 9],
  nt: [10, 11, 12, 13, 14, 15, 16, 17, 18],
};

interface IWhereToChargeSection {
  onScrollHandler: (index: number) => void;
}

type TWhereToChargeSectionProps = IWhereToChargeSection &
  HTMLAttributes<HTMLDivElement>;

const WhereToChargeSection: React.FC<TWhereToChargeSectionProps> = (props) => {
  const { onScrollHandler, ...otherProps } = props;

  const [containerRef, containerSprings] = useInView(() => ({
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
    once: false,
    config: { tension: 30, friction: 25 },
    delay: 1000,
  }));

  const isDesktop = useMediaQuery("(min-width: 768px)");
  const isMobile = useMediaQuery("(max-width: 767px)");

  const goNextSection = () => {
    onScrollHandler(2);
  };

  return (
    <div
      ref={containerRef}
      className="flex flex-col items-center h-full justify-center p-8 w-full"
      {...otherProps}
    >
      <SectionTitle
        chineseTitle="ASGARD EV 充電站網絡"
        englishTitle="Where to Charge"
      />

      {/* Only render on mobile */}
      {isMobile && <EvInfoSwiperMobile goNextSection={goNextSection} />}
      {/* Only render on desktop */}
      {isDesktop && <EvInfoSwiperDesktop goNextSection={goNextSection} />}
    </div>
  );
};

export default WhereToChargeSection;
